module.exports = __webpack_public_path__ + "static/media/front.90e361ea.jpg";